import React, { useState } from 'react';
import './styles.scss';

interface ZoomableImageProps {
  src: string;
  alt: string;
}

const ZoomableImage = ({ src, alt }: ZoomableImageProps) => {
  const [isZoomed, setIsZoomed] = useState(false);

  const toggleZoom = () => {
    setIsZoomed(!isZoomed);
  };

  return (
    <div
      className={`zoomable-image-container ${isZoomed ? 'zoomed' : ''}`}
      onClick={!isZoomed ? toggleZoom : undefined} // Disable background click in zoomed view
    >
      {isZoomed && (
        // eslint-disable-next-line react/button-has-type
        <button
          className="close-icon"
          onClick={e => {
            e.stopPropagation();
            setIsZoomed(false);
          }}
        >
          ✕
        </button>
      )}
      <img src={src} alt={alt} className="zoomable-image" />
    </div>
  );
};

export default ZoomableImage;
